module.exports = __webpack_public_path__ + "img/nitja-kids-500px.0e31a630.svg";